import * as React from 'react';

import CommunicationBody from './CommunicationBody';

import CommunicationData from '../../interfaces/CommunicationData';

interface Props {
  currentMail: boolean;
  communicationData: CommunicationData;
}

class GetCommunicationData extends React.PureComponent<Props> {

  render () {
    const { communicationData, currentMail } = this.props;

    if (communicationData.data && communicationData.data.length) {
      return communicationData.data.map((item, key) => {
        return (
          <CommunicationBody
            currentMail={currentMail}
            key={key}
            status={item.status}
            date={item.datesent}
            email={item.fromemail}
            subject={item.subject} />
        );
      });
    } else {
      return null;
    }
  }
}

export default GetCommunicationData;
